import React from 'react';
import { Tooltip, Button, Alert } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
var useStyles = makeStyles()({
  ellipses: {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
});
export default function BlockMsg(_ref) {
  var message = _ref.message,
    severity = _ref.severity,
    buttonText = _ref.buttonText,
    icon = _ref.icon,
    action = _ref.action;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var button = action ? React.createElement(Button, {
    "data-testid": "reload_button",
    onClick: action,
    startIcon: icon
  }, buttonText) : null;
  return React.createElement(Alert, {
    severity: severity,
    action: button,
    classes: {
      message: classes.ellipses
    }
  }, React.createElement(Tooltip, {
    title: message
  }, React.createElement("div", null, message)));
}